import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
`

export const Dialog = styled.dialog`
  background-color: rgb(246, 246, 246);
  border: 0;
  outline: none;
  height: calc(100% - var(--headerHeight, 67px));
  left: 0;
  justify-content: center;
  max-width: initial;
  padding: 36px;
  position: fixed;
  top: var(--headerHeight, 67px);
  width: 100%;
  z-index: 2;

  &::backdrop {
    background-color: transparent;
  }

  @media screen and (min-width: 992px) {
    height: calc(100% - 90px);
    top: var(--headerHeight, 90px);
  }
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`

export const ImageWrapper = styled.div`
  margin-bottom: 24px;

  animation: ${pulse} 1.5s infinite ease-in-out;
`
